import React, { useState } from "react";
import {
  Form,
  Input,
  Upload,
  Button,
  Spin,
  Typography,
  Card,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { UploadOutlined } from "@ant-design/icons";
import "../adminStyles.css";

const { Title } = Typography;

const CreateLanguage = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("admin"));

  // Handle image change and store raw file object
  const onImageChange = ({ fileList }) => {
    if (fileList.length > 0) {
      setImageFile(fileList[0].originFileObj);
    } else {
      setImageFile(null);
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    const formData = new FormData();

    if (imageFile) {
      formData.append("image", imageFile);
    }

    formData.append("language_short_name", values.language_short_name);
    formData.append("language_full_name", values.language_full_name);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_APIURL}/admin/createlanguage`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      const response = await res.json();

      if (response?.status_code === 200) {
        toast.success(t("Language_Success"));
        navigate("/admin/language/manage");
      } else {
        toast.error(response?.message || response?.err || "Upload failed");
      }
    } catch (err) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {t("Admin")} - {t("add_Language")}
        </title>
      </Helmet>

      <Title level={3} className="pb-2">
        {t("add_Language")}
      </Title>

      <Card className="max-w-lg mx-auto shadow">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="space-y-4"
        >
          <Form.Item
            label={`${t("add_Language_srt")} (Ex: en, hi)`}
            name="language_short_name"
            rules={[{ required: true, message: t("Required") }]}
          >
            <Input placeholder={t("add_Language_srt")} />
          </Form.Item>

          <Form.Item
            label={t("Language_county_Image")}
            name="image"
            valuePropName="fileList"
            getValueFromEvent={(e) => e.fileList}
          >
            <Upload
              listType="picture"
              maxCount={1}
              beforeUpload={() => false}
              onChange={onImageChange}
              accept="image/*"
            >
              <Button icon={<UploadOutlined />}>
                {t("add_new_product_T_img_info")}
              </Button>
            </Upload>
          </Form.Item>

          <Form.Item
            label={t("Language_full_name")}
            name="language_full_name"
            rules={[{ required: true, message: t("Required") }]}
          >
            <Input placeholder={t("Language_full_name")} />
          </Form.Item>

          <div className="flex justify-center gap-4">
            <Link to="/admin/language/manage">
              <Button danger>{t("Cancel")}</Button>
            </Link>
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary btn-sm text-white"
            >
              {t("Save")}
            </button>
          </div>
        </Form>

        {loading && (
          <div className="flex justify-center mt-4">
            <Spin />
          </div>
        )}
      </Card>
    </>
  );
};

export default CreateLanguage;

